import mvtInputGeo from '@/common/components/mvtinputgeo/mvt-inputgeo.vue';
import { mapGetters } from 'vuex';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';

export default {
    name: 'veteransWelcome',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['viewport', 'glb'])
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Find a Veterans Real Estate Agent',
                    hotleadType: 'veteranshublead',
                    buttonText: 'Connect Now',
                    showZipcode: false,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                    isVeteransHub: true,
                    showGeo: true,
                },
            });
        },
        show3rdPartyForm(id, url, evt) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
              id: id,
              url: url,
              trigger: this.$options.name,
              cta: resolveClickCta('', evt, 'SEARCH'),
            });
        }
    }
};